// extracted by mini-css-extract-plugin
export default {"requirementsTitle":"requirementsTitle_QGqEesQ","conditionsParagraph":"conditionsParagraph_C4hkGxJ"};